import { http } from '../../config/axios'

export default function getPerfilOpcoes(idFranquia?: string | null): Promise<any[]> {
  return http
    .get('api/perfil/opcoes/' + encodeURIComponent(idFranquia ?? 'null'))
    .then((res) => {
      return res.data as any[]
    })
    .catch((error) => {
      console.error('Erro getPerfilOpcoes', error)
      throw Error(error.response.data)
    })
}
